import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, CalendarHolidays, Holiday } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeHoliday(request: Boundaries["removeHoliday"]["request"]): void;
}

function useRemoveHoliday(holiday: Identifiable<Holiday>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveHolidayRequestPending(holiday),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveHolidayRequestSuccess(holiday),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveHolidayRequestFailure(holiday),
    ),
    removeHoliday: core.removeHoliday,
  };
}

export { useRemoveHoliday };
